<sm-page-header [breadcrumb]="breadcrumb" title="clarification.report_request.plural"></sm-page-header>

<div class="card p-4 mt-4">
    <sm-data-table-builder *ngIf="dataTableObject" [dataTableObject]="dataTableObject"
        [datas]="data" [loading]="loading" [totalRecords]="totalRecords"></sm-data-table-builder>
</div>